import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../environments/environment";
import {Http, RequestOptions} from "@angular/http";
import {PostHeaderModel, postHeaderModelListFactory} from "./post-header.model";
import {SnowridersService} from "./snowriders.service";

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  constructor(private http: Http, private snowridersService: SnowridersService) {}
  years: string[] = [];
  events: PostHeaderModel[] = [];

  ngOnInit() {
    this.snowridersService.setLogoVisibility(true);

    this.http.post(
      `${environment.httpBase}/posts/`,
      {},
      new RequestOptions({withCredentials: true}),
    )
      .toPromise()
      .then(
        (result) => {
          const json = result.json();
          this.years = json.years;
          this.events = postHeaderModelListFactory(json.events);
        },
        (error) => {
          alert(error);
          console.error(error);
        },
      );
  }

  ngOnDestroy() {
    this.snowridersService.setLogoVisibility(false);
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/home.component.ts